import AddUserToWaitingList from '@/services/cms/waitingListService/AddUserToWaitingList';

export default class WaitingListService {
    addUserToWaitingList(incompleteRegistrant) {
        return (new AddUserToWaitingList()).handle(incompleteRegistrant);
    }
}
